/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Inbox_Header_BadgeInputs */

const en_inbox_header_badge = /** @type {(inputs: Inbox_Header_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Needs you: ${i?.n}`)
};

const id_inbox_header_badge = /** @type {(inputs: Inbox_Header_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perlu Anda: ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Needs you: {n}" |
*
* @param {Inbox_Header_BadgeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_header_badge = /** @type {((inputs: Inbox_Header_BadgeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Header_BadgeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_header_badge(inputs)
	return en_inbox_header_badge(inputs)
});